import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  IFilePropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/FilePropertyTypeStrategy/types/IFilePropertyTypeInterfaces'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'

export function useFileValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Dropdown

  const fullValueToText = (value: IFilePropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    return String(value?.count || 0)
  }

  return $$({
    fullValueToText,
    strategyComponentType,
  })
}
